import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { ApplicationForm } from "./ApplicationForm";

interface ApplicationDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const ApplicationDialog = ({ open, onOpenChange }: ApplicationDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto p-4 sm:p-6">
        <DialogHeader>
          <DialogTitle className="text-fluid-xl md:text-fluid-2xl">Apply to HTICU</DialogTitle>
        </DialogHeader>
        <ApplicationForm onComplete={() => onOpenChange(false)} />
      </DialogContent>
    </Dialog>
  );
};
